.plan-highlights {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: var(--lineup-plan-grid-row-highlights-title) / var(--lineup-plan-grid-row-end);
  gap: var(--space-8);

  background-color: var(--white);
  color: var(--gray-637381);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  padding: var(--space-16);

  &.is-current-plan {
    background-color: var(--gray-F9FAFB);
  }
}

.summary-title {
  grid-area: highlights-title;
  color: var(--default--text-color--17);
}

.feature-list {
  grid-area: highlights-features;
  list-style: none;

  display: flex;
  flex-flow: column nowrap;
  gap: var(--space-8);
}

.feature-summary-list-item {
  display: flex;
  gap: var(--space-4);
}

.small-checkmark {
  color: var(--green-05b45e);
  margin-top: 2px;
  height: 12px;
  width: 12px;
  flex-shrink: 0;
}

.small-circle {
  color: var(--gray-637381);
  height: 4px;
  width: 4px;
  padding: 5px;
  flex-shrink: 0;
}

.feature-summary-list-item-text {
  color: var(--default--text-color--6);
}
